import { LegalLayout } from '../components/LegalLayout';

export default function Datenschutz() {
  return (
    <LegalLayout title="Datenschutzerklärung">
      <p className="text-sm text-slate-500">
        Diese Datenschutzerklärung erläutert Art, Umfang und Zweck der Verarbeitung personenbezogener
        Daten innerhalb unseres Online-Angebots Kivera und der damit verbundenen Webseiten,
        Funktionen und Inhalte.
      </p>

      <h2>1. Verantwortlicher</h2>
      <p>
        Verantwortlich im Sinne der Datenschutz-Grundverordnung (DSGVO) ist:<br /><br />
        <strong>SideQuestGuy.com</strong><br />
        Arno Strehle<br />
        Stresemannplatz 2<br />
        01309 Dresden<br />
        Deutschland<br />
        E-Mail: <a href="mailto:datenschutz@kivera.de">datenschutz@kivera.de</a>
      </p>

      <h2>2. Allgemeines zur Datenverarbeitung</h2>
      <p>
        Wir erheben und verwenden personenbezogene Daten unserer Nutzer grundsätzlich nur, soweit
        dies zur Bereitstellung einer funktionsfähigen Website sowie unserer Inhalte und Leistungen
        erforderlich ist. Die Erhebung und Verwendung personen­bezogener Daten unserer Nutzer
        erfolgt regelmäßig nur nach Einwilligung des Nutzers (Art. 6 Abs. 1 lit. a DSGVO) oder auf
        einer der weiteren in Art. 6 DSGVO genannten Rechtsgrundlagen.
      </p>

      <h2>3. Erhobene Daten und Verarbeitungszwecke</h2>

      <h3>3.1 Registrierung & Nutzerkonto (Vermieter)</h3>
      <p>
        Bei der Registrierung als Vermieter verarbeiten wir folgende Daten:
      </p>
      <ul>
        <li>Name</li>
        <li>E-Mail-Adresse</li>
        <li>Passwort (gespeichert ausschließlich als bcrypt-Hash, niemals im Klartext)</li>
        <li>Einladungscode</li>
        <li>Zeitstempel der Registrierung</li>
      </ul>
      <p>
        <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung).
        <br />
        <strong>Speicherdauer:</strong> Bis zur Löschung des Nutzerkontos.
      </p>

      <h3>3.2 Verwaltete Stammdaten (Immobilien, Einheiten, Vermieter, Mieter, Kosten)</h3>
      <p>
        Im Rahmen der Anwendung verarbeiten Sie als Vermieter personen­bezogene Daten Ihrer Mieter
        sowie Stammdaten Ihrer Immobilien (Adressen, Flächen, Mietverhältnisse, Vorauszahlungen,
        Belege etc.). Diese Daten werden ausschließlich im Auftrag des jeweiligen Vermieters
        gespeichert.
      </p>
      <p>
        <strong>Rolle:</strong> Für diese Daten agieren wir als <em>Auftragsverarbeiter</em> im
        Sinne von Art. 28 DSGVO. Auf Anforderung schließen wir mit Vermietern einen
        Auftragsverarbeitungsvertrag (AVV).
        <br />
        <strong>Speicherdauer:</strong> Bis zur Löschung durch den Vermieter oder Vertragsende.
      </p>

      <h3>3.3 Mieterportal-Logins</h3>
      <p>
        Für das Mieterportal verarbeiten wir folgende Daten:
      </p>
      <ul>
        <li>E-Mail-Adresse des Mieters</li>
        <li>Passwort (bcrypt-Hash)</li>
        <li>Verknüpfung zum Mieterstammsatz</li>
        <li>Login-Zeitstempel</li>
      </ul>
      <p>
        <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung gegenüber dem Vermieter).
      </p>

      <h3>3.4 Beleg-Uploads</h3>
      <p>
        Hochgeladene Belege (PDF, JPG, PNG) werden direkt auf dem Anwendungsserver in
        Deutschland gespeichert. Die Dateien werden ausschließlich für die Erstellung der
        Nebenkostenabrechnung und deren Nachvollziehbarkeit verwendet und nicht an Dritte
        weitergegeben.
      </p>

      <h3>3.5 Server-Log-Dateien</h3>
      <p>
        Bei jedem Aufruf unseres Dienstes werden automatisch folgende Daten in Logfiles erfasst:
      </p>
      <ul>
        <li>IP-Adresse (verkürzt / anonymisiert)</li>
        <li>Datum und Uhrzeit</li>
        <li>Zugriffsstatus / HTTP-Statuscode</li>
        <li>Aufgerufene URL</li>
        <li>User-Agent / Browser-Typ</li>
      </ul>
      <p>
        <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an
        sicherer Bereitstellung).
        <br />
        <strong>Speicherdauer:</strong> Maximal 14 Tage.
      </p>

      <h2>4. Cookies</h2>
      <p>
        Wir setzen ausschließlich technisch notwendige Cookies bzw. localStorage-Einträge ein
        (z. B. zur Speicherung des Login-Tokens). Es werden keine Tracking-, Marketing- oder
        Analyse-Cookies gesetzt.
      </p>

      <h2>5. Eingesetzte Dienstleister (Auftragsverarbeiter)</h2>

      <h3>5.1 Resend (E-Mail-Versand)</h3>
      <p>
        Für den Versand transaktionaler E-Mails (z. B. Mieterportal-Welcome, Abrechnungs-Versand,
        Passwort-Reset) nutzen wir den Dienst von Resend, Inc., 2261 Market Street #5039,
        San Francisco, CA 94114, USA. Übermittelt werden Empfänger-E-Mail-Adresse, Betreff und
        Inhalt der jeweiligen E-Mail.
        <br />
        <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. b DSGVO. Datenübermittlung in die USA
        auf Grundlage von Standardvertragsklauseln (SCC) gemäß Art. 46 DSGVO.
      </p>

      <h3>5.2 Hosting (Hetzner Online GmbH)</h3>
      <p>
        Die Anwendung wird auf einem virtuellen Server der <strong>Hetzner Online GmbH</strong>,
        Industriestraße 25, 91710 Gunzenhausen, Deutschland (Rechenzentrum in Deutschland) gehostet.
        Mit Hetzner besteht ein Auftrags­verarbeitungs­vertrag (AVV) gemäß Art. 28 DSGVO.
      </p>
      <p>
        Sowohl die Anwendungsdatenbank (MongoDB) als auch hochgeladene Belege (PDF, JPG, PNG)
        werden ausschließlich auf diesem Server gespeichert. Eine Übertragung an Drittländer oder
        weitere externe Cloud-Anbieter findet für diese Daten <strong>nicht</strong> statt.
      </p>
      <p>
        Weitere Informationen zum Datenschutz bei Hetzner:{' '}
        <a href="https://www.hetzner.com/de/rechtliches/datenschutz" target="_blank" rel="noopener noreferrer">
          hetzner.com/de/rechtliches/datenschutz
        </a>
      </p>

      <h2>6. Ihre Rechte als betroffene Person</h2>
      <p>Sie haben das Recht auf:</p>
      <ul>
        <li><strong>Auskunft</strong> über Ihre bei uns gespeicherten Daten (Art. 15 DSGVO)</li>
        <li><strong>Berichtigung</strong> unrichtiger Daten (Art. 16 DSGVO)</li>
        <li><strong>Löschung</strong> (Art. 17 DSGVO)</li>
        <li><strong>Einschränkung der Verarbeitung</strong> (Art. 18 DSGVO)</li>
        <li><strong>Datenübertragbarkeit</strong> (Art. 20 DSGVO)</li>
        <li><strong>Widerspruch</strong> gegen die Verarbeitung (Art. 21 DSGVO)</li>
        <li><strong>Beschwerde</strong> bei einer Aufsichtsbehörde (Art. 77 DSGVO)</li>
      </ul>
      <p>
        Zur Ausübung Ihrer Rechte genügt eine formlose Mitteilung an{' '}
        <a href="mailto:datenschutz@kivera.de">datenschutz@kivera.de</a>.
      </p>

      <h2>7. Zuständige Aufsichtsbehörde</h2>
      <p>
        Sächsische Datenschutz- und Transparenzbeauftragte<br />
        Devrientstraße 5<br />
        01067 Dresden<br />
        <a href="https://www.datenschutz.sachsen.de" target="_blank" rel="noopener noreferrer">
          www.datenschutz.sachsen.de
        </a>
      </p>

      <h2>8. Datensicherheit</h2>
      <p>
        Wir treffen technische und organisatorische Sicherheitsmaßnahmen, um Ihre Daten vor
        Manipulation, Verlust und unberechtigtem Zugriff zu schützen. Dazu zählen u. a. TLS-
        Verschlüsselung sämtlicher Verbindungen, gehashte Passwörter (bcrypt), Privilege Separation
        zwischen Vermieter- und Mieter-Zugängen sowie regelmäßige Updates.
      </p>

      <h2>9. Änderungen dieser Datenschutzerklärung</h2>
      <p>
        Wir behalten uns vor, diese Datenschutzerklärung anzupassen, damit sie stets den aktuellen
        rechtlichen Anforderungen entspricht oder Änderungen unserer Leistungen widerspiegelt.
      </p>

      <p className="text-sm text-slate-500 mt-12">
        Stand: {new Date().toLocaleDateString('de-DE', { month: 'long', year: 'numeric' })}
      </p>
    </LegalLayout>
  );
}
